import { CIcon } from '~/icons/types'

export const ciDirections: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'm22.314 10.1-8.171-8.34a3.074 3.074 0 0 0-4.286 0L1.685 10.1a3 3 0 0 0 .045 4.243l8.17 8a3.017 3.017 0 0 0 4.2 0l8.17-8a3 3 0 0 0 .044-4.243Zm-5.784 1.43-2 2a.75.75 0 0 1-1.06-1.06l.719-.72H10.8a1.608 1.608 0 0 0-1.226.625A2.644 2.644 0 0 0 9 14.049V15a.75.75 0 1 1-1.5 0v-.952a4.108 4.108 0 0 1 .919-2.636A3.12 3.12 0 0 1 10.8 10.25h3.393l-.719-.72a.75.75 0 0 1 1.06-1.06l2 2a.75.75 0 0 1-.004 1.06Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'directions',
  type: 'solid'
}
